export default "__VITE_ASSET__YWLBuIDk__"